import {
  getFileExtension,
  isImageByMimeType,
  resizeImage,
  validateFile,
} from '../utils/imageUtils';
import {safeFileArrayParse} from '../utils/safeFileArrayParse';

export const useFileUtilities = () => {
  return {
    safeFileArrayParse,

    resizeImage,
    isImageByMimeType,
    getFileExtension,
    validateFile,
  };
};
